import { render, staticRenderFns } from "./SuggestedCommunities.vue?vue&type=template&id=cb7527d0&scoped=true"
import script from "./SuggestedCommunities.vue?vue&type=script&lang=js"
export * from "./SuggestedCommunities.vue?vue&type=script&lang=js"
import style0 from "./SuggestedCommunities.vue?vue&type=style&index=0&id=cb7527d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7527d0",
  null
  
)

export default component.exports